import React, {forwardRef} from 'react';
import {useSelector} from "react-redux";
import {Menu} from "primereact/menu";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import useWorkspaceMembership from "../../../models/workspace-membership/use-workspace-membership";
import {useNavigate} from "react-router-dom";
import {selectableWorkspaceMemberships} from "../../../models/workspace-membership/workspace-membership-availability";

function SelectWorkspace(props, ref) {
    const {workspaceMembershipsData} = useSelector((state) => state.app);
    const workspaceMemberShip = useWorkspaceMembership();
    const translate = useTranslate();
    const navigate = useNavigate();

    const openCreateWorkspace = () => {
        navigate(props.createWorkspacePath || "/workspace/create");
    };

    // useUpdateEffect(()=>{
    //     console.log(workspaceMembershipsData);
    // },[workspaceMembershipsData]);

    const ItemTemplate = (data, options)=>{
        return data?.workspace?
        (
            <div className="px-2 py-2 cursor-pointer" onClick={options.onClick}>
                <div className="w-full border-round hover:surface-100 px-2 py-1 flex flex-column">
                    <span className="font-bold">{data?.workspace.name}</span>
                    {data?.isDefault&&<span className="text-400 text-xs">{translate("current-workspace")}</span>}
                </div>
            </div>
        ):(
                <div className="px-2 cursor-pointer" data-pc-section="content">
                    <Button className="w-full text-xs gap-2" icon={<Icon icon="mi mi:add_circle" className="text-lg"/>} label={translate("create-new-workspace")} onClick={options.onClick}/>
                </div>

            )
    }

    const command =async (e)=>{
        if (e.item?.documentId){
            await workspaceMemberShip.updateDefaultWorkspaceMembership(e.item?.documentId);
            props.onChange?.();
        }
    }

    let items = [
        {
            label:translate("my-desktops"),
            className:"text-xs text-400",
            items: selectableWorkspaceMemberships(workspaceMembershipsData).map(wm=>({...wm, template:ItemTemplate, command}))
        }
    ];
    items = [...items, {label:"add", template:ItemTemplate, command:openCreateWorkspace}]

    return (
        <div className="">
            <Menu className={props.className || "rtl w-20rem"} model={items} popup ref={ref} popupAlignment="right"/>
            {/*<DataView value={} layout="list" itemTemplate={ItemTemplate}/>*/}
        </div>
    );
}

export default forwardRef(SelectWorkspace);
